import { inject } from "@angular/core";
import { NavigationItem } from "@claas/claas-ui-components/navigation/navigation";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { EMPTY, catchError, pipe, switchMap, tap } from "rxjs";
import {
  CMS_ROUTE_PREFIX,
  CoreMediaNavigationClient,
} from "./coremedia-navigation.client";

interface NavigationState {
  items: NavigationItem[];
  status: "idle" | "loading" | "ready" | "error";
  error: unknown;
}

const initialState: NavigationState = {
  items: [],
  status: "idle",
  error: null,
};

export const navigationStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store, client = inject(CoreMediaNavigationClient)) => ({
    resolvePageByPath: (path: string, routePrefix = CMS_ROUTE_PREFIX) =>
      client.resolvePageByPath(path, routePrefix),
    load: rxMethod<void>(
      pipe(
        tap(() => patchState(store, { status: "loading", error: null })),
        switchMap(() =>
          client.loadNavigationItems().pipe(
            tap({
              next: (items) => {
                patchState(store, { items, status: "ready", error: null });
                client
                  .loadAdditionalTrees()
                  .pipe(catchError(() => EMPTY))
                  .subscribe();
              },
              error: (error) => {
                patchState(store, { status: "error", error });
                client
                  .loadAdditionalTrees()
                  .pipe(catchError(() => EMPTY))
                  .subscribe();
              },
            }),
          ),
        ),
      ),
    ),
  })),
);
